import styled from "styled-components";

export const TableWrapper = styled.div`
  width: 100%;
  padding: 17px 30px 24px;
  box-sizing: border-box;

  border-radius: 14px;
  border: 0.707px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  display: flex;
  flex-direction: column;
`;

export const TableTitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const SearchBox = styled.div`
  display: flex;
  width: 220px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 15px;
  background-color: #fff;
  padding: 3px 15px;
  box-sizing: border-box;
  align-items: center;

  > input {
    flex: 1;
    border: none;
    outline: none;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 600;
  }

  input::placeholder {
    color: #b7b7b7;
  }

  .searchIcon {
    width: 40px;
    height: 40px;
    cursor: pointer;
    text-align: right;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const HeaderLine = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  width: 100%;
  height: 1.5px;
  background: #d9d9d9;
`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;

  .name {
    width: 22%;
  }
  .exchange {
    width: 9%;
  }
  .count {
    width: 11%;
  }
  .limit {
    width: 12%;
  }
  .buyLimit {
    width: 13%;
  }
  .price {
    width: 12%;
  }
  .userPrice {
    width: 14%;
  }
  .action {
    width: 16%;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 5px 20px;
  box-sizing: border-box;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-height: 420px;
`;

export const TableItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 48px;
  padding: 8px 20px;
  box-sizing: border-box;
  border-radius: 13.94px;
  background: #ecf0f3;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    color: #121212;
    text-align: center;
    word-break: keep-all;
  }

  > .item.exchange.available {
    color: #7f25fb;
    font-weight: 700;
  }

  > .item.exchange.unavailable {
    color: #121212;
    font-weight: 700;
  }

  > .item.action {
    > .buy {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 64px;
      height: 30px;
      padding: 0 14px;
      border-radius: 8px;
      background: #7f25fb;
      color: #fff;
      font-family: Pretendard;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      box-sizing: border-box;
    }

    > .disabled {
      color: #969696;
      font-family: Pretendard;
      font-size: 13px;
      font-weight: 500;
    }
  }
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;

export const PaginationBox = styled.div`
  width: 100%;
  display: flex;
  padding: 20px 0 0;
`;
